import { AppLocale } from './locales';

export const LanguageLabels: Record<AppLocale, string> = {
  [AppLocale.en]: 'English',
  [AppLocale.fr]: 'Français',
  [AppLocale['es-419']]: 'Español',
};
